import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./MegaMenu.css";
import { SlArrowDown } from "react-icons/sl";
import { SlPhone } from "react-icons/sl";
import bellavegalogo from "../img/bellavegalogo.png";
import herotote from "../img/hero-tote.jpeg";
import slingred1 from "../img/sling-red-1.jpg";
import herohandbag from "../img/hero-handbag.jpeg"

const MegaMenu = () => {

  const [megaOpen, setMegaOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMegaOpen(false);
    setChecked(false);
  }, [megaOpen]);


    return (
      <header class="navbar">
      <div class="nav-container">
    
        <div class="logo"><a href="/"> <img src={bellavegalogo} /> </a></div>
    
        <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} id="menu-toggle" />
        <label for="menu-toggle" class="hamburger">
          <span></span>
          <span></span>
          <span></span>
        </label>
    
        <nav class="nav">
          <ul class="nav-links">
          {!megaOpen && (
            <>
            <li><a href="/"><h4>Home</h4></a></li>
    
            <li class="mega-parent">
              <a href="#">
                <h4>Tote Bag <span className="slarrow"><SlArrowDown /></span></h4>
            </a>
    
            
              <div class="mega-menu">
                <div class="mega-grid">
    
                  <div class="mega-col">
                    <h4>Tote Bag</h4>
                    <Link to="totebag">
                    <a href="#" onClick={() => setMegaOpen(!megaOpen)} >Large tote bag</a>
                    <a href="#" onClick={() => setMegaOpen(!megaOpen)} >Medium tote bag</a>

                    </Link>
                  </div>
    
                  <div class="mega-cta">
                    {/* <h3>Need Expert Advice?</h3>
                    <p>Talk to our experienced Chartered Accountants today.</p>
                    <a href="#ba" class="btn">Book Consultation</a> */}
                    <img src={herotote} alt="Tote bag" />
                  </div>
    
                </div>
              </div>
            </li>
    
    
    
            <li class="mega-parent">
              <a href="#"><h4>Sling Bag <span className="slarrow"><SlArrowDown /></span></h4></a>
    
              
              <div class="mega-menu">
                <div class="mega-grid">
    
                  <div class="mega-col">
                    <h4>Sling bag</h4>
                    <Link to="slingbag">
                    <a href="#" onClick={() => setMegaOpen(!megaOpen)}>Large sling bag</a>
                    <a href="#" onClick={() => setMegaOpen(!megaOpen)}>Medium sling bag</a>
                    </Link>
                  </div>
    
                  <div class="mega-cta">
                    {/* <h3>Need Expert Advice?</h3>
                    <p>Talk to our experienced Chartered Accountants today.</p>
                    <a href="#ba" class="btn">Book Consultation</a> */}
                    <img src={slingred1} alt="Sling bag" />
                  </div>
    
                </div>
              </div>
            </li>
    
    
    
            <li class="mega-parent">
              <a href="#"><h4>Party Bag <span className="slarrow"><SlArrowDown /></span></h4></a>
    
              
              <div class="mega-menu">
                <div class="mega-grid">
    
                  <div class="mega-col">
                    <h4>Party Bag</h4>
                    <Link to="partybag">
                      <a href="#tm" onClick={() => setMegaOpen(!megaOpen)}>Medium party bag</a>
                    </Link>
                  </div>
    
                  <div class="mega-cta">
                    {/* <h3>Need Expert Advice?</h3>
                    <p>Talk to our experienced Chartered Accountants today.</p>
                    <a href="#ba" class="btn">Book Consultation</a> */}
                    <img src={herohandbag} alt="Party bag" />
                  </div>
    
                </div>
              </div>
            </li>
    
            <li>
              <Link to="contactuspage">
                <a href="#contact-us" onClick={() => setMegaOpen(!megaOpen)}><h4>Contact Us</h4></a>
              </Link>
            </li>
            <li><a href="#" class="phn" onClick={() => setMegaOpen(!megaOpen)}><SlPhone/> 9470503300</a></li>
            </>
            )}
          </ul>
        </nav>
    
      </div>
    </header>
    );
}

export default MegaMenu;